export default "https://cdn-static.gokick.com/assets/d8950a20925d8040d2b2bc8b449b43040bc9b501/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";